export const SET_LOADING_DATA = '@sponsored/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@sponsored/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@sponsored/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@sponsored/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@sponsored/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@sponsored/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@sponsored/SAVE_REQUEST';
export const SAVE_SUCCESS = '@sponsored/SAVE_SUCCESS';

export const DELETE_ITEM = '@sponsored/DELETE_ITEM';
export const EDIT_ITEM = '@sponsored/EDIT_ITEM';

export const SEARCH = '@sponsored/SEARCH';

export const SET_PAGE = '@sponsored/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@sponsored/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@sponsored/SET_ORDER';
export const SET_ORDERBY = '@sponsored/SET_ORDEBY';

export const GET_PRODUCT_LIST_REQUEST = '@sponsored/GET_PRODUCT_LIST_REQUEST';
export const GET_PRODUCT_LIST_SUCCESS = '@sponsored/GET_PRODUCT_LIST_SUCCESS';
